<script setup lang="ts">
	import { ref } from 'vue';
	import VendorFilter from './VendorFilter.vue';
	import VendorMap from './VendorMap.vue';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		mag: String
	});
	
	const showVendors = ref(false);
	const vendors = ref([]);
	const lastMag = ref("");
	const lastZip = ref("");

	function showMap(emittedVendors, mag, zip) {
		showVendors.value=true;
		vendors.value=emittedVendors;
		lastZip.value=zip;
		lastMag.value=mag;
	}
</script>
<template>
	<table class="form vendorTable" style="overflow: auto;">
		<thead>
			<tr>
				<th>
					<sym-icon name="web"/> Navigátor pro hledání prodejního místa
				</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td>
					<div class="vendorArea">
						<transition name="fade" mode="out-in">
							<div v-if="!showVendors"> 
								<vendor-filter @show-vendors="showMap" :only-mag="mag" :last-mag="lastMag" :last-zip="lastZip"></vendor-filter>
							</div>
							<div v-else>
								<vendor-map @show-filter="showVendors=false" :vendors="vendors"></vendor-map>
							</div>
						</transition>
					</div>
				</td>
			</tr>
		</tbody>
		<tfoot>
			<tr>
				<td style="padding-bottom: 5px;"><i>Systém vyhledává prodejní místa distributora, kam byl časopis dodán.
					V průběhu prodeje může dojít k vyprodání časopisu na vyhledaném místě.</i></td>
			</tr>
			<tr class="status">
				<td>© 2006 - 2024 ESPRIT BOHEMIA s.r.o. | všechna práva vyhrazena</td>
			</tr>
		</tfoot>
	</table>
</template>

<style>
.vendorArea {
	min-height: 550px;
}	
	
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease-out;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}	

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.vendorTable {
	margin: 0 auto;
	width: 80%;
	max-width: 800px;
}
</style>